<template>
  <MDBSideNav right v-model="viewProject" mode="push" contentSelector="#ProjectTagging" :sidenavWidth="354">
    <div v-if="selectedProject" class="project-info">
      <ProjectTaggingViewProjectTitle />
      <Splitpanes horizontal class="default-theme">
        <Pane min-size="15" class="details-list-pane">
          <ProjectTaggingViewProjectDetailList />
        </Pane>
        <Pane min-size="15" class="members-pane">
          <ProjectTaggingViewProjectMembersCount />
          <ProjectTaggingViewProjectMembersList />
        </Pane>
      </Splitpanes>
      <ProjectTaggingViewProjectPagination />
    </div>
  </MDBSideNav>
</template>

<style lang="scss" scoped>
.project-info {
  display: grid;
  flex-direction: column;
  grid-template-rows: auto 1fr auto;
  height: 100%;
  background-color: $neutral-0;
}
.splitpanes.default-theme {
  overflow-y: auto;
}
.splitpanes.default-theme .splitpanes__pane {
  background-color: $neutral-0;
  overflow-y: auto;
}
.splitpanes.default-theme .splitpanes__splitter {
  border-color: $neutral-40;
}
.detail-list-pane {
  border-bottom: 1px solid $neutral-40;
}
.members-pane {
  display: grid;
  grid-template-rows: auto 1fr;
}
</style>

<script>
import { MDBSideNav } from 'mdb-vue-ui-kit';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
import { storeToRefs } from 'pinia';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import ProjectTaggingViewProjectTitle from './ProjectTaggingViewProjectTitle.vue';
import ProjectTaggingViewProjectDetailList from './ProjectTaggingViewProjectDetailList.vue';
import ProjectTaggingViewProjectPagination from './ProjectTaggingViewProjectPagination.vue';
import ProjectTaggingViewProjectMembersCount from './ProjectTaggingViewProjectMembersCount.vue';
import ProjectTaggingViewProjectMembersList from './ProjectTaggingViewProjectMembersList.vue';
export default {
  name: 'ProjectTaggingViewProject',
  components: {
    MDBSideNav,
    Splitpanes,
    Pane,
    ProjectTaggingViewProjectTitle,
    ProjectTaggingViewProjectDetailList,
    ProjectTaggingViewProjectPagination,
    ProjectTaggingViewProjectMembersCount,
    ProjectTaggingViewProjectMembersList,
  },
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { viewProject, selectedProject } = storeToRefs(projectTaggingStore);

    return {
      viewProject,
      selectedProject,
    };
  },
};
</script>
